import * as React from 'react';
import { CircularProgress, Typography } from '@mui/material';

interface LoadingProps {
    text?: string;
    fontSize?: number;
    color?: string;
    height?: number;
    width?: number
}

export default function LoadingSpinner(props: LoadingProps) {

    return (
        <React.Fragment>
            <div style={{ textAlign: "center" }}>
                <span
                    style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                        height: props.height ?? 20,
                        width: props.width ?? 20,
                    }}
                >
                    <CircularProgress
                        style={{
                            color: props.color ?? "gray",
                        }}
                        size={props.height ?? 20}
                    />
                </span>
                <Typography style={{
                    color: props.color !== undefined ? props.color : "gray",
                    fontSize: props.fontSize !== undefined ? props.fontSize : 14,
                    paddingLeft: 10,
                    verticalAlign: "top",
                    display: "inline"
                }}>
                    {props.text}
                </Typography>
            </div>
        </React.Fragment>
    );
}
